module.exports = __webpack_public_path__ + "static/img/case-gl-page-bg-03.a31e7be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/gl/case-gl-page-bg-03.png
// module id = HAAk
// module chunks = 1